import proj4 from "proj4";
import { register } from "ol/proj/proj4";
proj4.defs(
    "EPSG:28992",
    "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +towgs84=565.417,50.3319,465.552,-0.398957,0.343988,-1.8774,4.0725 +units=m +no_defs"
);
proj4.defs("EPSG:4326", "+proj=longlat +datum=WGS84 +no_defs");

register(proj4);

import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import Fill from "ol/style/Fill";
import Circle from "ol/style/Circle";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import GeoJSON from "ol/format/GeoJSON";

import { tile } from 'ol/loadingstrategy';

import { createXYZ } from 'ol/tilegrid';

export function createWFSLayers() {

    var layers = {}

    var backgroundStyle = new Style({
        stroke: new Stroke({
            color: 'rgba(100, 100, 100, 0.5)',
            lineDash: [2, 5],
            width: 2
        }),
        image: new Circle({
            radius: 3,
            stroke: new Stroke({
                color: 'rgba(100, 100, 100, 0.5)'
            }),
            fill: new Fill({
                color: 'rgba(100, 100, 100, 0.5)'
            })
        })
    })
    var foregroundStyle = new Style({
        stroke: new Stroke({
            color: 'rgba(0, 0, 255, 1.0)',
            width: 2
        }),
        image: new Circle({
            radius: 3,
            stroke: new Stroke({
                color: 'rgba(0, 0, 255, 1.0)'
            }),
            fill: new Fill({
                color: 'rgba(0, 0, 255, 1.0)'
            })
        })
    })
    var perceelSource = new VectorSource(
        {
            displayInLayerSwitcher: false,
            format: new GeoJSON(),
            url: function (extent) {
                return 'https://geodata.nationaalgeoregister.nl/kadastralekaart/wfs/v4_0?service=WFS&'
                    + 'version=2.0.0&request=GetFeature&typename=kadastralekaartv3:perceel&'
                    + 'outputFormat=application/json&srsname=EPSG:28992&'
                    + 'bbox=' + extent.join(',') + ',EPSG:28992';
            },
            strategy: tile(createXYZ())
        });

    var perceelVectorStyle = function (feature, resolution) {
        if (layers.perceelVector.get("backgroundStyleMode")) {
            return [backgroundStyle]
        } else {
            return [foregroundStyle]
        }
    }

    layers.perceelVector = new VectorLayer({
        displayInLayerSwitcher: false,
        name: "perceel",
        title: "perceel",
        source: perceelSource,
        maxResolution: 1.3,
        style: perceelVectorStyle
    });
    layers.perceelVector.set("backgroundStyleMode", true)


    var pandSource = new VectorSource(
        {
            format: new GeoJSON(),
            url: function (extent) {
                return 'https://service.pdok.nl/lv/bag/wfs/v2_0?service=WFS&'
                    + 'version=2.0.0&request=GetFeature&typename=bag:pand&'
                    + 'outputFormat=application/json&srsname=EPSG:28992&'
                    + 'bbox=' + extent.join(',') + ',EPSG:28992';
            },
            //strategy : ol.loadingstrategy.bbox
            strategy: tile(createXYZ())
        });

    var pandVectorStyle = function (feature, resolution) {
        if (layers.pandVector.get("backgroundStyleMode")) {
            return [backgroundStyle]
        } else {
            return [foregroundStyle]
        }
    }

    layers.pandVector = new VectorLayer({
        displayInLayerSwitcher: false,
        name: "pand",
        title: "pand",
        source: pandSource,
        maxResolution: 1.3,
        style: pandVectorStyle
    });
    layers.pandVector.set("backgroundStyleMode", true)



    var verblijfsobjectSource = new VectorSource(
        {
            format: new GeoJSON(),
            url: function (extent) {
                return 'https://service.pdok.nl/lv/bag/wfs/v2_0?service=WFS&'
                    + 'version=2.0.0&request=GetFeature&typename=bag:verblijfsobject&'
                    + 'outputFormat=application/json&srsname=EPSG:28992&'
                    + 'bbox=' + extent.join(',') + ',EPSG:28992';
            },
            strategy: tile(createXYZ())
        });

    var verblijfsobjectVectorStyle = function (feature, resolution) {
        if (layers.pandVector.get("backgroundStyleMode")) {
            return [backgroundStyle]
        } else {
            return [foregroundStyle]
        }
    }

    layers.verblijfsobjectVector = new VectorLayer({
        displayInLayerSwitcher: false,
        name: "verblijfsobject",
        title: "verblijfsobject",
        source: verblijfsobjectSource,
        maxResolution: 1.0,
        style: verblijfsobjectVectorStyle
    });
    layers.verblijfsobjectVector.set("backgroundStyleMode", true)

    return layers;

}

